// Google Analytics 4 E-commerce event helpers
// These only fire if GA4 is configured via REACT_APP_GA_MEASUREMENT_ID

function gtag() {
  if (window.gtag) {
    window.gtag.apply(null, arguments);
  }
}

export function trackPageView(path, title) {
  gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
  });
}

export function trackViewItem(product) {
  gtag('event', 'view_item', {
    currency: product.currency || 'GBP',
    value: product.discountedPrice || product.price,
    items: [{
      item_id: product._id,
      item_name: product.name,
      price: product.discountedPrice || product.price,
      item_category: product.category,
    }],
  });
}

export function trackAddToCart(product, quantity) {
  gtag('event', 'add_to_cart', {
    currency: product.currency || 'GBP',
    value: (product.discountedPrice || product.price) * quantity,
    items: [{
      item_id: product._id,
      item_name: product.name,
      price: product.discountedPrice || product.price,
      quantity,
    }],
  });
}

export function trackRemoveFromCart(product, quantity) {
  gtag('event', 'remove_from_cart', {
    currency: product.currency || 'GBP',
    value: (product.discountedPrice || product.price) * quantity,
    items: [{
      item_id: product._id,
      item_name: product.name,
      price: product.discountedPrice || product.price,
      quantity,
    }],
  });
}

export function trackBeginCheckout(items, total, currency) {
  gtag('event', 'begin_checkout', {
    currency: currency || 'GBP',
    value: total,
    items: items.map(item => ({
      item_id: item._id || item.productId,
      item_name: item.name,
      price: item.discountedPrice || item.price,
      quantity: item.quantity,
    })),
  });
}

export function trackPurchase(orderId, items, total, currency) {
  gtag('event', 'purchase', {
    transaction_id: orderId,
    currency: currency || 'GBP',
    value: total,
    items: items.map(item => ({
      item_id: item._id || item.productId,
      item_name: item.name,
      price: item.discountedPrice || item.price,
      quantity: item.quantity,
    })),
  });
}

export function trackSearch(searchTerm) {
  gtag('event', 'search', {
    search_term: searchTerm,
  });
}

export function trackViewItemList(listName, products) {
  gtag('event', 'view_item_list', {
    item_list_name: listName,
    items: products.slice(0, 10).map((p, i) => ({
      item_id: p._id,
      item_name: p.name,
      price: p.discountedPrice || p.price,
      index: i,
    })),
  });
}
